/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */

import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import uuid from 'uuid';
import { ApiHeadersService } from './api-headers';
import { cfbGateways } from '@cigna/cigna-for-brokers/shared/util';

@Injectable()
export class HttpInterceptorWrapper implements HttpInterceptor {
  constructor(private apiHeadersService: ApiHeadersService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    let serviceReferenceId: string | null = null;
    const requestId = uuid.v4();

    try {
      serviceReferenceId =
        new URL(req.url).searchParams.get('service_reference_id') ||
        req.body?.service_reference_id;
      if (serviceReferenceId) {
        sessionStorage.setItem('service_reference_id', serviceReferenceId);
      }

      // check api request url is from cfeGateways if so please add cigna-trace-id header only
      const isCfbgateway = cfbGateways.some((gateway) =>
        req.url.includes(Object.values(gateway)[0]),
      );
      if (isCfbgateway) {
        req = req.clone({
          headers: req.headers
            .set(
              'x-request-id',
              serviceReferenceId ? serviceReferenceId : requestId,
            )
            .set('x-cigna-trace-id', this.getCignaTraceId()),
        });
      }

      // eslint-disable-next-line no-empty
    } catch (err) {}

    return next.handle(req);
  }

  getCignaTraceId(): string {
    let cignaTraceId = '';
    if (window.location.href.includes('public')) {
      cignaTraceId =
        this.apiHeadersService.generateApiHeaders()['x-cigna-public-trace-id'];
    } else {
      cignaTraceId =
        this.apiHeadersService.generateApiHeaders()['x-cigna-secure-trace-id'];
    }
    return cignaTraceId;
  }
}
